
































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'

     


    import PageRequest from '@/store/entities/page-request'
  
     //入库订单
    class PageordermanagementRequest extends PageRequest{
        keyword:string='';
        stime:Date;
        etime:Date;
        ordtime: Date[] = [];
        status:number=-1;
        type:number=2;
    }
    
    @Component({
       // components:{CreateOrderManagement,Editordermanagement}
    })
    export default class ordermanagementwarehousing extends AbpBase{
       
       edit(){
         
            this.editModalShow=true;
           
        }

        pagerequest:PageordermanagementRequest=new PageordermanagementRequest();

        createModalShow:boolean=false;
        editModalShow:boolean=false;
        
        get list(){
             
            return this.$store.state.ordermanagement.cklist;
        };
        get loading(){
            return this.$store.state.ordermanagement.loading;
        }
        create(){
          //  this.$store.state.ordermanagement.ordertime=this.currentTime()
              
              this.createModalShow=true;
              this.$store.state.ordermanagement.isdispose=false;
             // this.$store.state.ordermanagement.type=1;
        }


        pageChange(page:number){
            this.$store.commit('ordermanagement/setCurrentPage',page);
            this.getpage();
        }
        pagesizeChange(pagesize:number){
            this.$store.commit('ordermanagement/setPageSize',pagesize);
            this.getpage();
        }
        async getpage(){
            this.pagerequest.type=2;
            this.pagerequest.maxResultCount=this.pageSize;
            this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
            if (this.pagerequest.ordtime.length > 0) {
            this.pagerequest.stime = this.pagerequest.ordtime[0];
    }
    if (this.pagerequest.ordtime.length > 1) {
           this.pagerequest.etime = this.pagerequest.ordtime[1];
    }

            
            await this.$store.dispatch({
                type:'ordermanagement/getStatisticsDataTime',
                data:this.pagerequest
            })
        }
         



        get pageSize(){
            return this.$store.state.ordermanagement.pageSize;
        }
        get totalCount(){
            return this.$store.state.ordermanagement.totalCount;
        }
        get currentPage(){
            return this.$store.state.ordermanagement.currentPage;
        }
        columns=[{
            title:this.L('OrderType'),
            key:'name'
        }
       
        ,{
            title:this.L('OrderWeightALL'),
            key:'weight',
            
        }
        ,{
            title:this.L('OrderNumALL'),
            key:'count',
            
        }
        
]
         async created(){
           // this .pagerequest.type=1;
          // this.$store.state.ordermanagement.type=1;
            this.getpage();
           // this.getCompanyInformation_All();
            //this.getWastetype_All();
   
        }

      /*   xlsximpt(){
 
     
           // 初始化内容数据
//const ws = XLSX.utils.aoa_to_sheet([['xlsx测试用例']]);		//独立设置标题
const testarray = [{
   '测试人员': 'NeptuneFlare',
   '测试用力': '123'
},
{
   '测试人员': 'NeptuneFlare1',
   '测试用力': '1234'
}];															//设置单元格内容
XLSX.utils.sheet_add_json( testarray, {origin: -1,});   
 
 // multiHeader: 一级表头
// multiHeader2：二级表头
// data：表格数据
// merges：需要合并的单元格
// filename：导出的excel文件名
var data=[{
   '测试人员': 'NeptuneFlare',
   '测试用力': '123'
},
{
   '测试人员': 'NeptuneFlare1',
   '测试用力': '1234'
}];	
 

        }

        
 
        
    }  
    */
    async xlsximpt() {

         
          
      
      await this.$store.dispatch({
                type:'ordermanagement/getStatisticsDataTime',
                data:this.pagerequest
            })
        let lt=this.$store.state.ordermanagement.cklist;
         
             
 
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
				/*
					lt.map((item) => { // 这里修改要下载的字段内容
				 
					  return item;
					});*/
        
   

  
				 
					  
    
					const filterVal = ['name', 'weight','count'];// 取出要下载的表头字段
					const tHeader = ['订单类型','总重量','总次数'];// 把表头字段定义成想要的中文或英文
					const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '出库转移统计');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}
    }
